// Mobile dock: a floating deep-navy pill with four destinations and a logo-blue
// menu button in the middle that opens the shared full-height menu panel.
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Briefcase, Film, Home, PhoneCall } from "lucide-react";
import { Burger } from "./Navigation";
import { menu, useMenuOpen } from "./nav/menuStore";

const LEFT = [
  { name: "Home", path: "/home", icon: Home },
  { name: "Services", path: "/services", icon: Briefcase },
];
const RIGHT = [
  { name: "Media", path: "/media", icon: Film },
  { name: "Voice", path: "/voiceagent", icon: PhoneCall },
];

const BottomTabs = () => {
  const { pathname } = useLocation();
  const open = useMenuOpen();

  const tab = ({ name, path, icon: Icon }: (typeof LEFT)[number]) => {
    const active = pathname === path;
    return (
      <Link
        key={path}
        to={path}
        className={`relative flex w-14 flex-col items-center gap-1 py-1.5 ${active ? "text-cx-link" : "text-cx-fg/65"}`}
      >
        {active && (
          <motion.span
            layoutId="dock-active"
            className="absolute -top-[9px] h-[2px] w-6 rounded-full bg-cx-accent"
            transition={{ type: "spring", stiffness: 420, damping: 32 }}
          />
        )}
        <Icon className="h-[18px] w-[18px]" strokeWidth={1.6} />
        <span className="font-hud text-[9px] uppercase tracking-[0.14em]">{name}</span>
      </Link>
    );
  };

  return (
    <motion.nav
      aria-label="Quick navigation"
      data-fx-inset-bottom
      initial={{ y: 90, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.3 }}
      className="fixed inset-x-3 bottom-3 z-[60] md:hidden safe-bottom"
    >
      <div className="mx-auto flex max-w-sm items-center justify-between rounded-full border border-cx-accent/25 bg-cx-bg/90 px-3 py-2 shadow-[0_18px_40px_-12px_rgba(0,0,0,0.7)] backdrop-blur-md">
        {LEFT.map(tab)}
        <button
          type="button"
          onClick={menu.toggle}
          aria-expanded={open}
          aria-controls="site-menu"
          aria-label={open ? "Close menu" : "Open menu"}
          className="-my-4 flex h-14 w-14 items-center justify-center rounded-full bg-[#2A629E] text-white shadow-[0_8px_24px_-6px_rgba(74,138,201,0.6)] transition-transform active:scale-95"
        >
          <Burger open={open} />
        </button>
        {RIGHT.map(tab)}
      </div>
    </motion.nav>
  );
};

export default BottomTabs;
